import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { currencyFormat } from "shared/components/helpers";
import { paymentOptionsForPlan } from "shared/components/payment-options";

function PaymentStepOne(props) {
  const paymentOptions = paymentOptionsForPlan(props.currentPlan);
  let amountClass = plan =>
    plan.type === "pastDue" && plan.value > 0 ? " text-danger" : "";

  let customValue;
  let customValueRefAssign = element => {
    // In React 16.3+ we want to replace this approach with `createRef`
    customValue = element;
  }

  function buttonClicked(plan) {
    if (plan.value === null && customValue) {
      customValue.focus();
    }
    props.setPaymentAmount(plan);
  };

  return (
    <div>
      <h4>Select a payment amount</h4>
      <div className="row">
        <ButtonGroup type="radio" className="col-md-12">
          {paymentOptions.map(option => (
            <Button
              key={option.type}
              className="rounded-box text-left col-md-12"
              onClick={() => buttonClicked(option)}
            >
              <input
                type="radio"
                checked={
                  props.selectedAmount.type === option.type &&
                  !props.emptyStepOption
                }
              />
              <span className={"radio-option" + amountClass(option)}>
                {option.value !== null ? (
                  currencyFormat(option.value)
                ) : (
                  <input
                    id="customValue"
                    type="text"
                    ref={customValueRefAssign}
                    onBlur={() => props.setPaymentAmount(option)}
                  />
                )}{" "}
                ({option.description})
              </span>
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </div>
  );
}

export default PaymentStepOne;



// WEBPACK FOOTER //
// ./src/home/components/payment-step-one.js